import { useEffect, useState } from "react"
import { Questions, ThreeYearChildQuestions, FiveYearChildQuestions } from './questions';
import { AnswersProps, QuestionProps } from ".";
import { useLocation } from "react-router-dom";
import { Question } from "./childSurvey";
import axios from "axios";

type ApiResponse = {
    [key: string]: QuestionResponse;
};

type QuestionResponse = {
    question_text: string;
    weight: number;
    type: string;
    question_id: string;
    response: string;
};

export const ViewReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const advance = queryParams.get('advance');
    const email = queryParams.get('email');
    const [questions, setQuestions] = useState<QuestionProps[] | Question[]>([])
    const [answers, setAnswers] = useState<AnswersProps>({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            if (!email) {
                console.error('No email provided');
                setLoading(false);
                return;
            }

            try {
                console.log('DEBUG - Original email from query params:', email);
                console.log('DEBUG - Encoded email:', encodeURIComponent(email));
                const url = `https://e6w2t1d2f1.execute-api.us-east-1.amazonaws.com/dev/survey/${email}${advance ? '?advance=true' : ''}`;
                console.log('DEBUG - Final URL:', url);
                const response = await axios.get(url);

                // Check if we have survey data
                if (response.data && response.data.responses && response.data.responses.length > 0) {
                    const surveyData = response.data.responses[0];

                    if (advance) {
                        // For advanced surveys - check if the data structure supports this
                        const formatedAnswer = transformCurrentApiToAnswers(surveyData.advanceSurvey || surveyData.responses);
                        setAnswers(formatedAnswer);
                        setQuestions(Object.keys(formatedAnswer).length === 20 ? [...ThreeYearChildQuestions] : [...ThreeYearChildQuestions, ...FiveYearChildQuestions]);
                    } else {
                        // For general surveys - use the current API format
                        const formatedAnswer = transformCurrentApiToAnswers(surveyData.responses);
                        setAnswers(formatedAnswer);
                        setQuestions(Questions);
                    }
                } else {
                    throw new Error('No survey data found');
                }
            } catch (error: any) {
                console.error('Error fetching questions:', error.response?.data?.message || error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [email, advance]);

    // Transform current API response format (array of question responses)
    const transformCurrentApiToAnswers = (apiResponseArray: any[]): { [questionId: string]: string } => {
        const result: { [questionId: string]: string } = {};
        apiResponseArray.forEach((item) => {
            if (item.questionId && item.selectedAnswer) {
                result[item.questionId.toString()] = item.selectedAnswer;
            }
        });
        return result;
    };

    // Legacy transformation function (keeping for compatibility)
    const transformApiToAnswers = (apiResponse: ApiResponse): { [questionId: string]: string } => {
        return Object.entries(apiResponse).reduce<{ [questionId: string]: string }>((acc, [key, value]) => {
            acc[value.question_id] = value.response;
            return acc;
        }, {});
    };

    if (loading) return <div className="fixed inset-0 flex justify-center items-center">
        <div className="border-y border-green-500 w-28 h-28 rounded-full animate-spin">
        </div>
    </div>
    
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl px-6 py-6">
                <img className="mx-auto h-20 my-6 w-auto" src='/newLogo.png' alt="Shvesa Logo" />
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">Survey Preview</h2>
                
                <div className="space-y-6">
                    {questions.map((question, index) => (
                        <div key={index} className="border-b border-gray-200 last:border-0 pb-4">
                            <p className="font-medium text-gray-700 mb-2">
                                {index + 1}. {question.question_text}
                            </p>
                            {answers[index + 1] ? (
                                answers[index + 1].includes('http') ? (
                                    <div className="flex items-center gap-4">
                                        <p className="text-gray-600">Answer: </p>
                                        {question.question_text.includes('[REC]') ? (
                                            <audio src={answers[index + 1]} controls />
                                        ) : (
                                            <img
                                                src={answers[index + 1]}
                                                alt={`Question ${index + 1} image`}
                                                className="w-40 h-40 object-fill rounded-lg shadow-md"
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <p className="text-gray-600 pl-6">
                                        Answer: {answers[index + 1]}
                                    </p>
                                )
                            ) : (
                                <p className="text-gray-600 pl-6">Answer: No</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
  )
}
